(() => {
  'use strict';
  if (window.NexoProductUtility) return;
  window.NexoProductUtility = true;
  document.addEventListener('click', event => {
    const current = event.target.closest('.nxo-edition-popover');
    document.querySelectorAll('.nxo-edition-popover[open]').forEach(details => {
      if (details !== current) details.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const opened = document.querySelectorAll('.nxo-edition-popover[open]');
    if (!opened.length) return;
    opened.forEach(details => {
      details.open = false;
      details.querySelector('summary').focus();
    });
  });
})();
